import { useEffect } from 'react';
import useApi from './useApi';
import { useVesselStore } from '../context/VesselContext';
import { VesselFactory } from '../factory/Vessel/VesselFactory';
import { VesselBM } from '../types/BusinessModel/Vessel/VesselBM';
import { buildQueryParams } from './endpoints/queryParamsHelper';
import useApiEndpoints from '../context/useApiEndpoints';
import apiEndpointUtils from 'src/utils/apiEndpointUtils';

export default () => {
    const { apiEndpoints } = useApiEndpoints();
    const { processApiEndpointError } = apiEndpointUtils();
    const { state, getApiData } = useApi();
    const { setVessel, setSelectedVessel, setIsVesselDataRetrieved } = useVesselStore();
    const vesselFactory = new VesselFactory();

    const getVessel = (imoNumber: number) => {
        getApiData({
            endpoint: apiEndpoints['getVessel'].url,
            queryParam: buildQueryParams({ imoNumber }),
            forceRefreshCache: true,
        });
    };

    useEffect(() => {
        if (state.status === 'success') {
            const vesselBM = state.result as unknown as VesselBM;
            const vessel = vesselFactory.getVessel(vesselBM, false);
            setVessel(vessel);
            setSelectedVessel(vessel);
            setIsVesselDataRetrieved(true);
        } else {
            processApiEndpointError(state);
        }
    }, [state]);

    return { state, getVessel };
};
